module.exports = __webpack_public_path__ + "img/ic-narrow-right.4b113a75.svg";